import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import { Alert, AlertTitle, Box, IconButton, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { severities } from "../../../stack/environment/icons/iconExport";
const DetectionAlertScenarios = ({
  fullAlert = false,
  onClose = null,
  goToScenarios = () => {},
}) => {
  const colors = useColors();
  return (
    <Alert
      severity="error"
      icon={<SvgToIcon IconLogo={severities.HighSeverityIcon} />}
      sx={{
        background: colors.error_4percent,
        border: "1px solid " + colors.error_48percent,
        borderRadius: "8px",
        alignItems: "flex-start",
        "& .MuiAlert-message": {
          width: "100%",
        },
      }}
      action={
        onClose && (
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            sx={{ color: colors.action_active }}
            onClick={() => {
              onClose();
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        )
      }
    >
      <AlertTitle>
        <Typography
          variant={fullAlert ? "subtitle1" : "subtitle2"}
          sx={{ color: colors.text_primary }}
        >
          Active Threat Detected in Scenario{fullAlert && " #2"}
        </Typography>
      </AlertTitle>
      {fullAlert && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: colors.text_primary,
            }}
          >
            A live event was detected in your environment. This may indicate an
            active attacker in your system. Immediate action is required.
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          color: colors.error_main,
          cursor: "pointer",
        }}
        onClick={goToScenarios}
      >
        <Typography variant="overline">Investigate Now</Typography>
        <ArrowForwardIcon sx={{ width: "12px" }} />
      </Box>
    </Alert>
  );
};

export default DetectionAlertScenarios;
